<template>
  <div id="app">
    <app-header />
    <router-view />
    <app-footer />
    <mq-layout mq="tb">
      <app-scroll />
    </mq-layout>
  </div>
</template>

<script>
import 'normalize.css'
import 'ress'

import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppScroll from '@/components/AppScroll.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    AppScroll
  },
  watch: {
    '$route': function (to, from) {

      const conceptUpdater = () => {
        window.scrollTo(0, 0);
        this.$store.commit('updateCurrentSection', 'concept01');
      }

      const featureUpdater = () => {
        window.scrollTo(0, 0);
        this.$store.commit('updateCurrentSection', 'feature00');
      }

      const variationUpdater = () => {
        window.scrollTo(0, 0);
        this.$store.commit('updateCurrentSection', 'variation01');
      }

      if (to.path === '/concept') {
        setTimeout(conceptUpdater, 200);
      } else if (to.path === '/feature') {
        setTimeout(featureUpdater, 200);
      } else if (to.path === '/color-variation') {
        setTimeout(variationUpdater, 200);
      } else if (to.path !== from.path) {
        window.scrollTo(0, 0);
      }
    }
  }
}
</script>

<style lang="scss">
body {
  font-family: $baseFont;
  font-weight: 500;
  line-height: 1;
}

ul {
  list-style: none;
}

a {
  color: inherit;
  text-decoration: none;
}

header + * {
  padding-top: 62px;
}
</style>
